import { createContext } from 'react';
import type { MailFolder } from '../api/mailbox';

export interface MailFoldersContextValue {
  folders: MailFolder[];
  loading: boolean;
}

export const MailFoldersContext = createContext<MailFoldersContextValue>({
  folders: [],
  loading: false,
});
